import {Util} from 'yougile-util'
import {
  Checklist,
  ChecklistItem,
  DataObjectId,
  DeadlineStickerValue,
  StickerStateId,
  TasksListId
} from 'yougile-model'

export type DragDataObject =
  | {type: 'empty'}
  | {
      type: 'task'
      id: DataObjectId
      isDependent?: boolean
      listId?: TasksListId
    }
  | {
      type: 'sticker'
      stickerId: DataObjectId
      stateId?: StickerStateId | DeadlineStickerValue
      value?: string
    }
  | {type: 'user'; userId: DataObjectId}
  | {type: 'checklist'; list: Checklist; taskId: DataObjectId}
  | {
      type: 'checklist-item'
      list: Checklist
      item: ChecklistItem
      taskId: DataObjectId
    }
  | {type: 'company'; id: DataObjectId}
  | {type: 'my-task'; id: DataObjectId}
  | {type: 'project'; id: DataObjectId}
  | {type: 'api-code'; code: string}

export class DragData {
  private static current: DragDataObject = {type: 'empty'}
  private static addedClasses = new Set<string>()
  private static initializedAlready = false

  static init(): void {
    if (this.initializedAlready) {
      return
    }
    this.initializedAlready = true

    document.addEventListener('dragend', () => {
      setTimeout(() => {
        DragData.current = {type: 'empty'}
      }, 100)
    })
  }

  static set(event: {dataTransfer: DataTransfer}, data?: DragDataObject): void {
    event.dataTransfer.setData('Text', 'YouGile')
    DragData.setCurrent(data)
  }

  private static stopDrag(): void {
    for (const className of DragData.addedClasses) {
      document.body.classList.remove(className)
    }
    document.removeEventListener('mouseup', DragData.stopDrag)
    document.removeEventListener('dragend', DragData.stopDrag)
    document.removeEventListener('drop', DragData.stopDrag)
  }

  static setCurrent(data?: DragDataObject): void {
    DragData.current = data ? Util.clone(data) : {type: 'empty'}
    if (data && data.type !== 'empty') {
      const className = 'native-dragging--' + data.type
      DragData.addedClasses.add(className)
      document.body.classList.add(className)
      document.addEventListener('mouseup', DragData.stopDrag)
      document.addEventListener('dragend', DragData.stopDrag)
      document.addEventListener('drop', DragData.stopDrag)
    } else {
      DragData.stopDrag()
    }
  }

  static get(): DragDataObject | undefined {
    return DragData && Util.clone(DragData.current)
  }

  static setEffect(
    ev: {dataTransfer: DataTransfer},
    effect: 'copy' | 'move' | 'link' | 'none' | undefined
  ): void {
    if (ev?.dataTransfer && effect) {
      ev.dataTransfer.dropEffect = effect
    }
  }
}
